import React, { useContext } from 'react'
import { ReducerDispatchContext, ReducerContext } from '../reducers/reducerContext.js';
import { setVehiclesStock } from '../actions/actionsAppTest'
import { fetchSimulationVehiclesIfNeeded } from '../actions/actionsApiSimulation'
import TestVehicles from '../components/testCriteria/TestVehicles'

export default function ContTestVehiclesStock() {
  const dispatch = useContext(ReducerDispatchContext);
  const globalstate = useContext(ReducerContext);

  function onChangeVehicles(vehicles) {
    fetchSimulationVehiclesIfNeeded(globalstate, dispatch, {}, { vehiclesStock: vehicles }, null, null, false);
    dispatch(setVehiclesStock(vehicles));
  }
  return (
    <TestVehicles
      context={globalstate.testCriteria.context}
      data={globalstate.testCriteria.vehiclesStock}
      settings={globalstate.settings}
      onChangeVehicles={onChangeVehicles}
    />
  );
}
